import { __assign, __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import styles from './styles.css.js';
import { useStickyPosition } from './utils/use-sticky-position';
import mergeRefs from 'react-merge-refs';
function StaticNotifications(_a) {
    var children = _a.children, labels = _a.labels, isRefresh = _a.isRefresh, isMobile = _a.isMobile, navigationPadding = _a.navigationPadding, toolsPadding = _a.toolsPadding, maxWidth = _a.maxWidth;
    return (React.createElement("div", { className: clsx(styles.notifications, isRefresh && styles['notifications-refresh'], isMobile && isRefresh && styles['notifications-refresh-mobile'], !navigationPadding && styles['notifications-refresh-no-navigation-padding'], !toolsPadding && styles['notifications-refresh-no-tools-padding']), role: "region", "aria-label": labels === null || labels === void 0 ? void 0 : labels.notifications, style: isRefresh && !isMobile ? { maxWidth: maxWidth } : undefined }, children));
}
var StickyNotifications = React.forwardRef(function (props, ref) {
    var _a = useStickyPosition(props.topOffset), stickyRef = _a[0], placeholder = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: mergeRefs([ref, stickyRef]), className: styles['notifications-sticky'] },
            React.createElement(StaticNotifications, __assign({}, props))),
        placeholder));
});
export var Notifications = React.forwardRef(function (_a, ref) {
    var sticky = _a.sticky, rest = __rest(_a, ["sticky"]);
    return sticky ? React.createElement(StickyNotifications, __assign({}, rest, { ref: ref })) : React.createElement(StaticNotifications, __assign({}, rest));
});
//# sourceMappingURL=notifications.js.map